import { UUID } from '../../types/shared/UUID';
import { clientUrls } from '../../ui-toolkit/rest/ClientUrlFactory';
import { eLenderOrderTab } from '../../ui-toolkit/orders/interfaces/eLenderOrderTab';
import { ISelectOption } from '../../ui-toolkit';

// this Record associates a value of eLenderOrderTab with a function to generate a clientURL.
// it preserves the labels of lenderOrderTabs.
export const clientOrderTabNavigation: Record<eLenderOrderTab, ISelectOption<(orderId: UUID) => string>> = {
  main: { label: 'Overview', value: clientUrls.urlFor.clientOrderOverview },
  fees: { label: 'Fees', value: clientUrls.urlFor.clientOrderFees },
  title: { label: 'Title Summary', value: clientUrls.urlFor.clientOrderTitle },
};
